// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3N9t8","header":"PatientBlock_header__3WV8T","label":"PatientBlock_label__2SEX9","option":"PatientBlock_option__1LMyx"};